module.exports = __webpack_public_path__ + "assets/fonts/close.bc55d8e4.svg";